<template>
  <div class="disabled-monetary-display" style="">
    <span>{{ value | currency }}</span>
  </div>
</template>


<script>

export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style scoped lang="scss">
.disabled-monetary-display {
  border-radius: 4px; 
  border: 1px solid 1px solid #dee2e6; 
  padding: 4px 8px; 
  background-color: #e9ecef; 
  color: #8898aa; 
  font-size: 0.875rem;
}
</style>
